/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import {
  Dialog, TextField, Typography, Divider,
} from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Actions from '../actions';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  body: {
    width: '90%',
    margin: 'auto',
    marginBottom: 18,
  },
  paper: {
    padding: 22,
  },
  input: {
    marginTop: 6,
  },
});

const StyledTableCell = withStyles((theme) => {
  return {
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  };
})(TableCell);

function BasicTable({ fetchAllTherapist, updateTherapist, therapist }) {
  const classes = useStyles();
  const [state, setState] = useState({
    name: '',
    email: '',
    photoUri: '',
    designation: '',
  });
  const [list, setList] = useState(null);
  const [show, setShow] = useState(false);
  const handleChange = (e) => { return setState({ ...state, [e.target.name]: e.target.value }); };
  const toggleDialog = (item) => {
    if (item) {
      setState({
        _id: item._id,
        name: item.name ? item.name : '',
        email: item.email ? item.email : '',
        photoUri: item.photoUri ? item.photoUri : '',
        designation: item.designation ? item.designation : '',
      });
    }
    setShow(!show);
  };
  const handleSubmit = async () => {
    try {
      setShow(false);
      await updateTherapist(state);
      await fetchAllTherapist();
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    if (list === null && therapist === undefined) fetchAllTherapist();
    if (therapist !== undefined) setList(therapist);
  }, [therapist, list, fetchAllTherapist]);

  return (
    <TableContainer component={Paper} className={classes.body}>
      <Dialog open={show} onClose={toggleDialog}>
        <Paper className={classes.paper}>
          <Typography variant="h4">Edit Therapist Details</Typography>
          <Divider />
          <TextField
            fullWidth
            name="name"
            value={state.name}
            onChange={handleChange}
            label="Name"
            className={classes.input}
          />
          <TextField
            fullWidth
            name="email"
            value={state.email}
            onChange={handleChange}
            label="Email"
            className={classes.input}
          />
          <TextField
            fullWidth
            name="photoUri"
            value={state.photoUri}
            onChange={handleChange}
            label="Photo Uri"
            className={classes.input}
          />
          <TextField
            fullWidth
            name="designation"
            value={state.designation}
            onChange={handleChange}
            label="designation"
            className={classes.input}
          />
          <Button
            variant="contained"
            fullWidth
            className={classes.input}
            color="primary"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Paper>
      </Dialog>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Name</StyledTableCell>
            <StyledTableCell align="right">Email</StyledTableCell>
            <StyledTableCell align="right">Photo Uri</StyledTableCell>
            <StyledTableCell align="right">Designation</StyledTableCell>
            <StyledTableCell align="right">Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list && list.map((item, i) => {
            return (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  {item.name}
                </TableCell>
                <TableCell align="right">{item.email}</TableCell>
                <TableCell align="right">{item.photoUri}</TableCell>
                <TableCell align="right">{item.designation}</TableCell>
                <TableCell align="right">
                  <Button
                    onClick={() => { return toggleDialog(item); }}
                    startIcon={<Edit />}
                    variant="outlined"
                    color="primary"
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    therapist: state.therapist.list,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BasicTable);
